import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Cómo accedo al libro? ¿Me envían algo a mi casa?',
    answer: '¡Estamos en la era digital! Una vez que realizas el pago, recibes acceso INSTANTÁNEO por correo electrónico. Descargas todo a tu celular, tablet o computador. No hay cargos mensuales, no hay costos ocultos. Pagas una sola vez y eso es todo.'
  }, {
    question: 'No tengo experiencia previa. ¿Este libro es para mí?',
    answer: '¡ABSOLUTAMENTE! Este libro fue diseñado especialmente para principiantes. Empezamos desde lo más básico y avanzamos paso a paso. Si puedes seguir una receta de cocina, puedes hacer jabones artesanales con este libro. No necesitas experiencia previa, ni conocimientos de química, ni un gran capital.'
  }, {
    question: '¿Hay algún cargo mensual?',
    answer: 'NO. Este es un pago ÚNICO de $9.97 USD por acceso de por vida a todo el paquete. Sin suscripciones, sin renovaciones, sin sorpresas.'
  }, {
    question: '¿Puedo vender los jabones que haga con tus recetas?',
    answer: '¡Por supuesto! De hecho, ese es uno de los objetivos principales. Muchas de nuestras alumnas generan entre $100 y $500 dólares mensuales vendiendo jabones a familiares, amigos, vecinos y por redes sociales. El bono de Estrategias de Venta te enseña exactamente cómo hacerlo.'
  }, {
    question: '¿Qué pasa si soy mala en manualidades?',
    answer: 'Creo que CUALQUIER persona puede hacer jabones artesanales. Tengo muchas recetas fáciles para principiantes que no requieren muchas herramientas ni materiales costosos. Si puedes derretir glicerina y verterla en un molde, ya puedes hacer tu primer jabón. Es un proceso simple: solo una serie de pasos sencillos. Mis recetas te guiarán a través de TODO. Un paso a la vez.'
  }, {
    question: 'No puedo costear muchos materiales ahora...',
    answer: '¡Perfecto! Porque aprenderás exactamente qué necesitas comprar para cada receta específica. No desperdiciarás dinero en materiales innecesarios. Además, conocerás el método de las grandes marcas para ahorrar hasta 60% en materiales. Y la lista de proveedores te llevará a los lugares más económicos de tu país.'
  }, {
    question: '¿Cómo funciona la garantía?',
    answer: 'Tu compra está protegida por Hotmart, empresa de educación online líder desde 2011. Si no estás satisfecha por cualquier razón, simplemente escribes un correo y recibes el 100% de tu dinero de vuelta. Sin preguntas, sin complicaciones.'
  }, {
    question: '¿A quién va dirigido este libro?',
    answer: 'A emprendedoras que quieran iniciar un negocio propio innovador y altamente rentable. A madres que buscan generar ingresos desde casa. A cualquier persona creativa que quiera aprender una habilidad que se convierte en un negocio real.'
  }];
  return <section className="w-full py-16 md:py-24 px-4 bg-cream" data-id="element-39">
      <div className="max-w-4xl mx-auto" data-id="element-40">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-41">
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-brown mb-4" data-id="element-42">
            ¿Tienes Preguntas? Aquí Están Las Respuestas
          </h2>
        </motion.div>

        {/* FAQ Items */}
        <div className="space-y-4" data-id="element-43">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.05
        }} className="bg-white rounded-xl shadow-md border-2 border-sage/20 overflow-hidden" data-id="element-44">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-sage/5 transition-colors" aria-expanded={openIndex === index} data-id="element-45">
                <span className="font-playfair text-xl font-semibold text-brown pr-4" data-id="element-46">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-terracotta flex-shrink-0 transition-transform ${openIndex === index ? 'transform rotate-180' : ''}`} data-id="element-47" />
              </button>
              <AnimatePresence data-id="element-48">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-49">
                    <div className="px-6 pb-6" data-id="element-50">
                      <p className="font-inter text-base text-brown/80 leading-relaxed" data-id="element-51">
                        {faq.answer}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}